import { createContext } from "react";

export const UserContext = createContext({
    decks: [],
    matrix: ['rec7lQw6DtIJP45dn-fre', 'rec7lQw6DtIJP45dn-rom', 'rec7lQw6DtIJP45dn-rus', 'rec7lQw6DtIJP45dn-ams', 'rec7lQw6DtIJP45dn-spa', 'rec7lQw6DtIJP45dn-por',
        'rec4nBx7PmDA3Y7Ji-fre', 'rec4nBx7PmDA3Y7Ji-ams',
        'reclNHMgbbYroSaNq-fre', 'reclNHMgbbYroSaNq-ams',
        'rec6ogwslaOOKRmRI',
        'recv3YSPQJmjKZEBy']
});
